// extracted by mini-css-extract-plugin
module.exports = {"container":"Toggle_container__2vHpu","knobs":"Toggle_knobs__2M0j5","checkbox":"Toggle_checkbox__1h0sr","layer":"Toggle_layer__3dx_Z"};